import {NavListItem} from '../../../js/custom-components/nav/menu-item-component';

class MenuComponent extends React.Component{

	constructor(props) {
    super(props);
  }
	renderNavListItems(){			
		return this.props.menuEntires.map((menuEntry, index) => {
			return <NavListItem 
					key={index}
					name={menuEntry.name}
					iconClass={menuEntry.iconClass} 
					link={menuEntry.link}
					/>
		})
	}
	render(){		
		return (
			<nav role="navigation" aria-label="primary" className={"nav " + (this.props.menuIsVisible ? 'visible' : '')}>
				<div className="shadow"></div>
				<div className="nav__container">
					<div className="nav-logo">
						<svg id="tacheman" onClick={this.props.onSpecialsClick} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 0 60 60" width="50" height="50"><defs><path d="M52.08 3.89C53.69 3.89 54.99 5.19 54.99 6.8C54.99 13.49 54.99 30.67 54.99 37.36C54.99 38.97 53.69 40.27 52.08 40.27C43.88 40.27 22.2 40.27 14 40.27C12.39 40.27 11.09 38.97 11.09 37.36C11.09 30.67 11.09 13.49 11.09 6.8C11.09 5.19 12.39 3.89 14 3.89C22.2 3.89 43.88 3.89 52.08 3.89Z" id="b1qp8yMT8"></path><path d="M48.59 11.82C50.11 11.82 51.35 13.06 51.35 14.58C51.35 21.14 51.35 38.03 51.35 44.58C51.35 46.11 50.11 47.34 48.59 47.34C40.8 47.34 20.2 47.34 12.41 47.34C10.88 47.34 9.64 46.11 9.64 44.58C9.64 38.03 9.64 21.14 9.64 14.58C9.64 13.06 10.88 11.82 12.41 11.82C20.2 11.82 40.8 11.82 48.59 11.82Z" id="a5Y00xr1by"></path><path d="M25.54 11.82C27.61 11.82 29.29 13.5 29.29 15.57C29.29 18.83 29.29 24.82 29.29 28.07C29.29 30.15 27.61 31.83 25.54 31.83C22.9 31.83 18.75 31.83 16.12 31.83C14.04 31.83 12.36 30.15 12.36 28.07C12.36 24.82 12.36 18.83 12.36 15.57C12.36 13.5 14.04 11.82 16.12 11.82C18.75 11.82 22.9 11.82 25.54 11.82Z" id="ds8LkJ6Ml"></path><path d="M23.7 15.81C25.03 15.81 26.12 16.89 26.12 18.22C26.12 20.09 26.12 23.27 26.12 25.13C26.12 26.47 25.03 27.55 23.7 27.55C22 27.55 19.33 27.55 17.63 27.55C16.3 27.55 15.22 26.47 15.22 25.13C15.22 23.27 15.22 20.09 15.22 18.22C15.22 16.89 16.3 15.81 17.63 15.81C19.33 15.81 22 15.81 23.7 15.81Z" id="g4lj1q0PYy"></path><path d="M21.85 20.24C22.28 20.24 22.64 20.6 22.64 21.03C22.64 21.51 22.64 22.14 22.64 22.62C22.64 23.05 22.28 23.41 21.85 23.41C21.28 23.41 20.37 23.41 19.81 23.41C19.37 23.41 19.01 23.05 19.01 22.62C19.01 22.14 19.01 21.51 19.01 21.03C19.01 20.6 19.37 20.24 19.81 20.24C20.37 20.24 21.28 20.24 21.85 20.24Z" id="a1AKSwjzgE"></path><path d="M29.29 20.91L34.06 20.91L34.06 24.07L29.29 24.07L29.29 20.91Z" id="btGras6f"></path><path d="M22.75 39.58C17.14 40.82 15.13 46.75 11.53 49.14C7.92 51.54 4.26 50.39 3.71 49.35C3.16 48.31 3.31 47.17 4.21 46.54C5.69 45.52 5.81 47.69 5.81 47.69C5.81 47.69 6.12 44.08 3.11 45.82C1.3 46.86 1.35 50.9 4.41 53.2C8.26 56.09 13.69 55.46 18.24 54.55C22.4 53.72 27.38 51.1 29.56 48.52C29.73 48.32 29.88 48.11 30 47.9C30.13 48.11 30.27 48.32 30.44 48.52C32.62 51.1 37.6 53.72 41.76 54.55C46.31 55.46 51.74 56.09 55.59 53.2C58.65 50.9 58.7 46.86 56.89 45.82C53.88 44.08 54.19 47.69 54.19 47.69C54.19 47.69 54.31 45.52 55.79 46.54C56.69 47.17 56.84 48.31 56.29 49.35C55.75 50.39 52.08 51.54 48.48 49.14C44.87 46.75 42.86 40.82 37.25 39.58C33.28 38.69 31.02 40.42 30 41.87C29.16 40.68 27.48 39.29 24.7 39.33C24.1 39.34 23.45 39.42 22.75 39.58Z" id="a4SbkkTHeT"></path><path d="M47.61 11.82C49.68 11.82 51.36 13.5 51.36 15.57C51.36 18.83 51.36 24.82 51.36 28.07C51.36 30.15 49.68 31.83 47.61 31.83C44.97 31.83 40.82 31.83 38.19 31.83C36.12 31.83 34.43 30.15 34.43 28.07C34.43 24.82 34.43 18.83 34.43 15.57C34.43 13.5 36.12 11.82 38.19 11.82C40.82 11.82 44.97 11.82 47.61 11.82Z" id="a3jwaBGTl2"></path><path d="M45.93 15.81C47.27 15.81 48.35 16.89 48.35 18.22C48.35 20.09 48.35 23.27 48.35 25.13C48.35 26.47 47.27 27.55 45.93 27.55C44.24 27.55 41.56 27.55 39.87 27.55C38.53 27.55 37.45 26.47 37.45 25.13C37.45 23.27 37.45 20.09 37.45 18.22C37.45 16.89 38.53 15.81 39.87 15.81C41.56 15.81 44.24 15.81 45.93 15.81Z" id="b2yZgH4Se0"></path><path d="M43.92 20.24C44.36 20.24 44.71 20.6 44.71 21.03C44.71 21.51 44.71 22.14 44.71 22.62C44.71 23.05 44.36 23.41 43.92 23.41C43.35 23.41 42.45 23.41 41.88 23.41C41.44 23.41 41.09 23.05 41.09 22.62C41.09 22.14 41.09 21.51 41.09 21.03C41.09 20.6 41.44 20.24 41.88 20.24C42.45 20.24 43.35 20.24 43.92 20.24Z" id="bz308vN69"></path></defs>
							<g>
								<g>
									<g>
										<use xlinkHref="#b1qp8yMT8" opacity="1" fill="#ffffff" fillOpacity="1"></use>
									<g>
										<use xlinkHref="#b1qp8yMT8" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1" strokeOpacity="1"></use>
									</g>
								</g>
								<g>
									<use xlinkHref="#a5Y00xr1by" opacity="1" fill="#ffffff" fillOpacity="1"></use>
									<g>
										<use xlinkHref="#a5Y00xr1by" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1" strokeOpacity="1"></use>
									</g>
								</g>
								<g>
									<use xlinkHref="#btGras6f" opacity="1" fill="#000000" fillOpacity="1"></use>
									<g>
										<use xlinkHref="#btGras6f" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1" strokeOpacity="1"></use>
									</g>
								</g>
								<g id="tacheman-tache">
									<use xlinkHref="#a4SbkkTHeT" opacity="1" fill="#000000" fillOpacity="1"></use>
									<g>
										<use xlinkHref="#a4SbkkTHeT" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1.66" strokeOpacity="1"></use>
									</g>
								</g>
								<g id="tacheman-left-eye">
									<g>
										<use xlinkHref="#ds8LkJ6Ml" opacity="1" fill="#ffffff" fillOpacity="1"></use>
										<g>
											<use xlinkHref="#ds8LkJ6Ml" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1" strokeOpacity="1"></use>
										</g>
									</g>
									<g>
										<use xlinkHref="#g4lj1q0PYy" opacity="1" fill="#ffffff" fillOpacity="1"></use>
										<g>
											<use xlinkHref="#g4lj1q0PYy" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1" strokeOpacity="1"></use>
										</g>
									</g>
									<g>
										<use xlinkHref="#a1AKSwjzgE" opacity="1" fill="#000000" fillOpacity="1"></use>
										<g>
											<use xlinkHref="#a1AKSwjzgE" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1" strokeOpacity="1"></use>
										</g>
									</g>
								</g>
								<g id="tacheman-right-eye">	
									<g>
										<use xlinkHref="#a3jwaBGTl2" opacity="1" fill="#ffffff" fillOpacity="1"></use>
										<g>
											<use xlinkHref="#a3jwaBGTl2" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1" strokeOpacity="1"></use>
										</g>
									</g>
									<g>
										<use xlinkHref="#b2yZgH4Se0" opacity="1" fill="#ffffff" fillOpacity="1"></use>
										<g>
											<use xlinkHref="#b2yZgH4Se0" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1" strokeOpacity="1"></use>
										</g>
									</g>
									<g>
										<use xlinkHref="#bz308vN69" opacity="1" fill="#000000" fillOpacity="1"></use>
										<g>
											<use xlinkHref="#bz308vN69" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="1" strokeOpacity="1"></use>
										</g>
									</g>
								</g>
							</g>
						</g>
					</svg>
					</div>
					<div className="nav__list__container">
						<ul className="nav__list">
							{this.renderNavListItems()}
						</ul>
					</div>
					<div className="dummyDiv"></div>
				</div>
			</nav>
		);
	}
}
export { MenuComponent };


// WEBPACK FOOTER //
// in/js/custom-components/nav/menu-component.js